import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DateHelper} from '../../helper/date.helper';

export const dateValidator =
    (message: string, translateService: TranslateService): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            // Here no Mandatory field validation
            return null;
        }
        let date: Date;
        if (!(control.value instanceof Date)) {
            // Check if control.value have the right Dateformat dd.mm.yyyy
            if (DateHelper.isCorrectDateFormat(control.value)) {
                // return invalid_Date if e.g. control.value = 35.20.2020
                date = DateHelper.parseToDate(control.value);
                if (date === DateHelper.INVALID_DATE) {
                    const invalidDateMessage = translateService.instant('UTILS.VALIDATION.VALID_DATE_DEFAULT');
                    return {
                        date: invalidDateMessage
                    };
                }
            } else {
                return {
                    date: message
                };
            }
        }
        return null;
    };
